module.exports = __webpack_public_path__ + "static/blended-1b326b5f196711e2a36112af1ce3ebe3.png";